module.exports = __webpack_public_path__ + "static/media/icondropdown.18d723b7.svg";